"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.raw = exports.sql = exports.LicenseCheckRequestSchema = exports.awsSignV4ConfigSchema = void 0;
const zod_1 = require("zod");
const awsSignV4ConfigBaseSchema = zod_1.z.object({
    awsRegion: zod_1.z.string(),
    awsAccessKey: zod_1.z.string(),
    awsSecretKey: zod_1.z.string(),
    // By default service is 'execute-api'
    awsService: zod_1.z.string().optional(),
    uri: zod_1.z.string(),
    headers: zod_1.z.record(zod_1.z.string()).optional(),
});
exports.awsSignV4ConfigSchema = zod_1.z.union([
    awsSignV4ConfigBaseSchema.extend({
        httpMethod: zod_1.z.enum(['GET', 'DELETE']),
    }),
    awsSignV4ConfigBaseSchema.extend({
        httpMethod: zod_1.z.enum(['POST', 'PUT', 'PATCH']),
        body: zod_1.z.any().optional(),
    }),
]);
exports.LicenseCheckRequestSchema = zod_1.z.object({
    board: zod_1.z.string().trim().min(1),
    licenseNumber: zod_1.z.string().optional(),
    firstName: zod_1.z.string().trim().min(1),
    lastName: zod_1.z.string().trim().min(1),
    additionalParams: zod_1.z.record(zod_1.z.string().trim().min(1), zod_1.z.string().trim().min(1)).optional(),
});
/**
 * Tagged template  to write sql queries with params that helps to avoid sql injection attacks.
 *
 * @example
 * sql`SELECT * from account_cache WHERE first_name=${firstName} AND _id in(${ids})`
 *
 * @example Using raw strings in query, WARNING do not put user input into raw function
 * sql`SELECT * from account_cache WHERE first_name is ${raw(findEmpty ? 'NULL' : 'NOT NULL')}`
 *
 * @example Adding Sub query
 * const subQuery = sql`SELECT id FROM organization_cache WHERE name = ${orgName}`;
 * const query = sql`SELECT * FROM account_cache where id in (${subQuery})`;
 */
function sql(strings, ...values) {
    const params = [];
    let query = '';
    strings.forEach((s, index) => {
        const arg = values[index];
        query += s;
        if (arg !== undefined) {
            if (Array.isArray(arg)) {
                query += arg.map(() => '?').join(', ');
                params.push(...arg);
            }
            else if (typeof arg === 'object' && 'isRaw' in arg) {
                query += arg.value;
            }
            else if (typeof arg === 'object' && 'query' in arg) {
                query += arg.query;
                params.push(...arg.params);
            }
            else {
                query += '?';
                params.push(arg);
            }
        }
    });
    return {
        query: query,
        params: params,
    };
}
exports.sql = sql;
/**
 * Add raw string into query. Might be useful if you have table name as constant or want to use boolean shorthand to construct dynamic query.
 * WARNING do not put any values that come from variables or user input, this WILL lead to SQL injection attacks.
 *
 * @example
 * const TABLE_NAME = 'accounts_cache'; // static constant;
 * sql`SELECT * from ${raw(TABLE_NAME)} WHERE first_name is ${raw(findEmpty ? 'NULL' : 'NOT NULL')}`
 */
function raw(param) {
    return {
        isRaw: true,
        value: param,
    };
}
exports.raw = raw;
